<div class="image-container" [class.show-overlay]="showOverlay">
  <img *ngIf="previewImageUrl else imagePlaceholder" class="img-responsive" [src]="previewImageUrl | safeUrl" [attr.alt]="altText">
  <ng-template #imagePlaceholder>
    <div class="placeholder-image bg-dark">
      <material-icon>image</material-icon>
    </div>
  </ng-template>
</div>
